// Note: types exposed from `index.d.ts`.
export {unified} from './lib/index.js'
